import { render } from "./remoteRenderView.vue?vue&type=template&id=86644056&ts=true"
import script from "./remoteRenderView.vue?vue&type=script&lang=ts"
export * from "./remoteRenderView.vue?vue&type=script&lang=ts"

import "./remoteRenderView.vue?vue&type=style&index=0&id=86644056&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__